// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace numUtil {
  export const getRandomInt = (): number => {
    return new Date().getTime() | 0;
  };
}





